import React, { Fragment } from 'react';
import isEmpty from 'lodash/isEmpty';

import CollapseContainer from '../Review/CollapseContainer';

type Props = {
  flightDetails: Object,
  returnFlightDetails: Object,
  totalAmount: string,
  unitPrice: Number,
};

const FlightSummary = ({
  flightDetails,
  returnFlightDetails,
  totalAmount,
  unitPrice,
}: Props) => (
  <CollapseContainer title="Flights" openCollapse={false} cost={totalAmount}>
    <FlightsInfo
      title={isEmpty(returnFlightDetails) ? 'Return' : 'Departure'}
      flightsInfo={flightDetails}
      unitPrice={Number(unitPrice).toLocaleString()}
    />
    {!isEmpty(returnFlightDetails) && (
      <FlightsInfo title="Return" flightsInfo={returnFlightDetails} unitPrice={unitPrice} />
    )}
  </CollapseContainer>
);

export default FlightSummary;

type FlightsInfoProps = {
  title: string,
  flightsInfo: {
    adult: string,
    adultFare: string,
    aircraftType: string,
    airline: string,
    arrival: string,
    arrivalTime: string,
    child: string,
    childFare: string,
    currency: string,
    departure: string,
    departureTime: string,
    flightDate: string,
    flightId: string,
    flightNo: string,
    freeBaggage: string,
    infant: string,
    infantFare: string,
    refundable: string,
    resFare: string,
    tax: string,
  },
};

const FlightsInfo = (props: FlightsInfoProps) => {
  const {
    title,
    flightsInfo: {
      departureTime,
      flightDate,
      airline,
      freeBaggage,
      flightNo,
      arrivalTime,
      currency,
      departure,
      arrival,
      refundable,
    },
    unitPrice,
  } = props;
  return (
    <Fragment>
      <h6>
        {title} Flight on {flightDate}
      </h6>
      <div className="flight-info-card">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div className="flight-logo-wrap">
            <div className="flight-logo">
              <img
                src="https://s3.amazonaws.com/honeyguide/assets/aillines.png"
                alt={airline}
              />
            </div>
            <p>{flightNo}</p>
            <p>Summit Airlines</p>
          </div>
          <div className="flight-detail">
            <div className="d-flex justify-content-between">
              <h5>{departureTime}</h5>
              <h5>{arrivalTime}</h5>
            </div>
            <p className="vertical-line">&nbsp;</p>
            <div className="d-flex justify-content-between">
              <p>{departure}</p>
              <p>{arrival}</p>
            </div>
          </div>
          <div className="flight-price">
            <h5>
              {currency} {unitPrice}
            </h5>
            <p>
              {refundable === 'T'
                ? 'Refundable'
                : refundable === 'F'
                ? 'Non-Refundable'
                : ''}
            </p>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <span>{freeBaggage && `${freeBaggage} max baggage`}</span>
        </div>
      </div>
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/screens/Trek/Self-Guided/Payment/FlightSummary.js